<app-admin-sidebar></app-admin-sidebar>
<div id="analytics" role="main" tabindex="-1" aria-label="Admin Analytics Page" class="content page">
  <div class="pub-list-header" [ngSwitch]="eventAction">
    <div *ngSwitchCase="null">
      <h1 i18n="@@analyticsTitleUsageAnalytics">Usage Analytics</h1>
      <p i18n="@@analyticsSubtitleUsageAnalytics">Usage analytics for your institution</p>
    </div>
    <div *ngSwitchCase="'refs'">
      <h1 i18n="Title for References Added|This is the title text for References Added@@analyticsTitleReferencesAdded">References Added</h1>
      <p i18n="References details text|Detail text@@analyticsSubtitleReferencesAdded">References Added analytics for your institution</p>
    </div>
    <div *ngSwitchCase="'accounts'">
      <h1 i18n="Title for Accounts Created|This is the title text for Accounts Created@@analyticsTitleAccountsCreated">Accounts Created</h1>
      <p i18n="Accounts details text|Detail text@@analyticsSubtitleAccountsCreated">Accounts created analytics for your institution</p>
    </div>
    <div *ngSwitchCase="'add'">
      <h1 i18n="Title for Publications Added|This is the title text for Publications Added@@analyticsTitlePublicationsAdded">Publications Added</h1>
      <p i18n="Publication details text|Detail text@@analyticsSubtitlePublicationsAdded">Publications your users most frequently added to their accounts</p>
    </div>
    <div *ngSwitchCase="'cite'">
      <h1 i18n="Title for Publications Cited|This is the title text for Publications Cited@@analyticsTitlePublicationsCited">Publications Cited</h1>
      <div class="publications-cited-text">
        <p i18n="Publication details text for EndNote Fusion word|Detail text@@analyticsSubtitlePublicationsCited">Publications most frequently cited by your users in EndNote Fusion for Word and Google Docs.</p>
        <i class="uxf-icon uxf-info-circle" tooltip="Data collection from Write-n-Cite through 2024, RCM since October 9, 2024" i18n-tooltip placement="bottom" tabindex="0"></i>
      </div>
    </div>
    <div *ngSwitchCase="'read'">
      <h1 i18n="Title for Publications Read|This is the title text for Rublications Read@@analyticsTitlePublicationsRead">Publications Read</h1>
      <p i18n="Publication details text for full-text articles|Detail text@@analyticsSubtitlePublicationsRead">Publications with full-text articles most frequently read by your users</p>
    </div>
    <div *ngSwitchCase="'view'">
      <h1 i18n="Title for Publications Viewed|This is the title text for Publications Viewed@@analyticsTitlePublicationsViewed">Publications Viewed</h1>
      <p i18n="Publication details text for metadata|Detail text@@analyticsSubtitlePublicationsViewed">Publications for which your users most frequently viewed metadata</p>
    </div>
  </div>
  <div class="row" *ngIf="!['accounts', 'refs'].includes(eventAction)">
    <div class="col-md-12" *ngIf="eventAction">
      <div class="dropdown-container">
        <div class="btn-group" dropdown>
          <button id="allTimeButton" dropdownToggle type="button" class="btn btn-default dropdown-toggle" [class.active]="selectedTime !== allTime[0]">
            {{selectedTime.label}} <span class="caret"></span>
          </button>
          <ul *dropdownMenu class="dropdown-menu" role="menu">
            <li role="allitem" id="All Time"><a class="dropdown-item" data-target="#" (click)="onSelect('time', allTime[0])" i18n="@@analyticsFilterAllTime">{{ allTime[0].label }}</a></li>
            <li role="allitem" id="now-356d"><a class="dropdown-item" data-target="#" (click)="onSelect('time', allTime[1])" i18n="@@analyticsFilterPastYear">{{ allTime[1].label }}</a></li>
            <li role="allitem" id="now-90d"><a class="dropdown-item" data-target="#" (click)="onSelect('time', allTime[2])" i18n="@@analyticsFilterPast90Days">{{ allTime[2].label }}</a></li>
            <li role="allitem" id="now-30d"><a class="dropdown-item" data-target="#" (click)="onSelect('time', allTime[3])" i18n="@@analyticsFilterPast30Days">{{ allTime[3].label }}</a></li>
          </ul>
        </div>
        <div class="btn-group" dropdown>
          <button dropdownToggle type="button" class="btn btn-default dropdown-toggle" [class.active]="selectedRole !== allRoles[0]">
            {{selectedRole.displayName}} <span class="caret"></span>
          </button>
          <ul *dropdownMenu class="dropdown-menu" role="menu">
            <li role="rolesitem" *ngFor="let x of allRoles"><a class="dropdown-item" data-target="#" (click)="onSelect('role', x)">{{x.displayName}}</a></li>
          </ul>
        </div>
        <div class="btn-group" dropdown>
          <button dropdownToggle type="button" class="btn btn-default dropdown-toggle" [class.active]="selectedDiscipline !== allDisciplines[0]">
            {{selectedDiscipline.displayName}} <span class="caret"></span>
          </button>
          <ul *dropdownMenu class="dropdown-menu" role="menu">
            <li role="disciplinesitem" *ngFor="let x of allDisciplines"><a class="dropdown-item" data-target="#" (click)="onSelect('discipline', x)">{{x.displayName}}</a></li>
          </ul>
        </div>
        <div class="btn-group" dropdown>
          <button dropdownToggle type="button" class="btn btn-default dropdown-toggle" [class.active]="selectedDepartment !== allDepartments[0]">
            {{selectedDepartment.displayName}} <span class="caret"></span>
          </button>
          <ul *dropdownMenu class="dropdown-menu" role="menu">
            <li role="departmentsitem" *ngFor="let x of allDepartments"><a class="dropdown-item" data-target="#" (click)="onSelect('department', x)">{{x.displayName}}</a></li>
          </ul>
        </div>

        <button class="btn btn-default download" (click)="downloadReport()">
          <i class="uxf-icon uxf-download"></i>
          <span i18n="Report Download Button|Button to download a report@@analyticsDownloadReportButton" class="ng-scope"> Download report</span>
        </button>
      </div>
    </div>
  </div>
  <br />
  <div class="row" *ngIf="!['accounts', 'refs'].includes(eventAction)">
    <div class="col-md-12">
      <div class="publication-list">
        <table class="table" id="publications" *ngIf="eventAction">
          <thead>
          <tr>
            <th i18n="Publication Data Details|Times Added@@analyticsTableHeadingTimesAdded" *ngIf="eventAction ==='add'">Times Added</th>
            <th i18n="Publication Data Details|Times Cited@@analyticsTableHeadingTimesCited" *ngIf="eventAction ==='cite'">Times Cited</th>
            <th i18n="Publication Data Details|Times Read@@analyticsTableHeadingTimesRead" *ngIf="eventAction ==='read'">Times Read</th>
            <th i18n="Publication Data Details|Times Viewed@@analyticsTableHeadingTimesViewed" *ngIf="eventAction ==='view'">Times Viewed</th>
            <th i18n="Publication Name|The name of the Publication@@analyticsTableHeadingPublicationName">Publication Name</th>
          </tr>
          </thead>
          <tbody>
            <tr *ngFor="let pub of publications">
              <td>{{pub.count}}</td>
              <td>{{pub.name}}</td>
            </tr>
            <tr *ngIf="publications && !publications.length">
              <td colspan="2" i18n="@@analyticsTableNoResults">No Results</td>
            </tr>
          </tbody>
        </table>
        <div class="spinner" *ngIf="publications === undefined && eventAction"></div>
      </div>
    </div>
  </div>
  <div class="row align-items" id="reportFilters" *ngIf="!eventAction || ['accounts', 'refs'].includes(eventAction)">
    <div class="btn-group btn-group-toggle separator" data-toggle="buttons" *ngIf="!eventAction">
      <button
              id="pageviewsBtn"
              class="btn btn-secondary active style-toggle"
             [class.active]="metric === 'screenPageViews'"
             tabindex="0"
             tooltip="Counts each time a user views an EndNote Fusion page" i18n-tooltip
             placement="bottom"
             (click)="onMetricChange('screenPageViews')"
             (keydown)="handleKeyPress($event, 'screenPageViews')"
             i18n="@@userAnalyticsPagereviwesTitle">
              <span class="glyphicon glyphicon-ok" *ngIf="metric === 'screenPageViews'"></span>
        Pageviews
      </button>
      <button class="btn btn-secondary style-toggle"
             [class.active]="metric === 'sessions'"
             tabindex="0"
             tooltip="Counts each time a user visits EndNote Fusion" i18n-tooltip
             placement="bottom"
             (click)="onMetricChange('sessions')"
             (keydown)="handleKeyPress($event, 'sessions')"
             i18n="@@userAnalyticsSessionsTitle">
              <span class="glyphicon glyphicon-ok" *ngIf="metric === 'sessions'"></span>
        Sessions
      </button>
    </div>
    <div class="btn-group btn-group-toggle separator" data-toggle="buttons" *ngIf="['accounts', 'refs'].includes(eventAction)">
      <button id="filtersButton" class="btn btn-secondary style-toggle" tabindex="0" i18n="@@userAnalyticsFilterButton" [ngClass]="{'active': showFilters}" (click)="showSharedFilters()">
        <span class="glyphicon rw-plus-thin"></span> &nbsp;Filters
      </button>
    </div>
    <div class="btn-group btn-group-toggle" data-toggle="buttons">
      <button class="btn btn-secondary btn-width style-toggle"
             [disabled]="disabled"
             [class.active]="grouping === 'day'"
             [tabindex]="disabled ? -1 : 0"
             (click)="onGroupingChange('day')"
             [ngClass]="getDisabledClass()"
             [ngClass]="{'disabled': disabled}"
             i18n="@@userAnalyticsDayTitle">
              <span class="glyphicon glyphicon-ok" *ngIf="grouping === 'day'"></span>
        Day
      </button>
      <button class="btn btn-secondary btn-width active style-toggle"
             [disabled]="disabled"
             [class.active]="grouping === 'month'"
             [tabindex]="disabled ? -1 : 0"
             (click)="onGroupingChange('month')"
             [ngClass]="getDisabledClass()"
             [ngClass]="{'disabled': disabled}"
             i18n="@@userAnalyticsMonthTitle">
              <span class="glyphicon glyphicon-ok" *ngIf="grouping === 'month'"></span>
        Month
      </button>
    </div>
    <div class="dropdown">
      <button class="btn btn-default dropdown-toggle style-button" type="button" id="dropdownMenu1" data-toggle="dropdown" aria-haspopup="true" aria-expanded="true">
        {{selectedTimeFrame}}
        <span class="caret"></span>
      </button>
      <ul class="dropdown-menu drop-li">
        <li (click)="onTimeFrameChange('mtd')"><a [ngClass]="{'selected-dropdown': timeFrame === 'mtd'}" href="javascript:void(0)">{{ localesSelectedTimeFrame['mtd'] }}</a></li>
        <li (click)="onTimeFrameChange('lmtd')"><a [ngClass]="{'selected-dropdown': timeFrame === 'lmtd'}" href="javascript:void(0)">{{ localesSelectedTimeFrame['lmtd'] }}</a></li>
        <li (click)="onTimeFrameChange('ytd')"><a [ngClass]="{'selected-dropdown': timeFrame === 'ytd'}" href="javascript:void(0)">{{ localesSelectedTimeFrame['ytd'] }}</a></li>
        <li (click)="onTimeFrameChange('lytd')"><a [ngClass]="{'selected-dropdown': timeFrame === 'lytd'}" href="javascript:void(0)">{{ localesSelectedTimeFrame['lytd'] }}</a></li>
        <li (click)="onTimeFrameChange('custom')"><a [ngClass]="{'selected-dropdown': timeFrame === 'custom'}" href="javascript:void(0)">{{ localesSelectedTimeFrame['custom'] }}</a></li>
      </ul>
    </div>

    <div class="datepicker-container" style="position: relative" *ngIf="timeFrame === 'custom'">
      <mat-form-field appearance="outline">
        <mat-date-range-input [min]="getMinDate()" [max]="maxDate">
          <input matStartDate i18n-placeholder="Start date Placeholder|Placeholder text for the input@@startDatePlaceholder"
                 placeholder="Start date" disabled [(ngModel)]="textStartDate">
          <input matEndDate i18n-placeholder="End date Placeholder|Placeholder text for the input@@endDatePlaceholder"
                 placeholder="End date" disabled [(ngModel)]="textEndDate">
        </mat-date-range-input>
        <mat-datepicker-toggle class="btn btn-default style-datepicker" matIconSuffix (click)="openDatepicker()"></mat-datepicker-toggle>
      </mat-form-field>
      <div id="calendar" *ngIf="calendarOpen" [cdkTrapFocus]="calendarOpen" [cdkTrapFocusAutoCapture]="true">
        <mat-calendar [selected]="selectedRangeValue"
                      [minDate]="getMinDate()"
                      [maxDate]="maxDate"
                      (selectedChange)="selectedChange($event)"
                      (closed)="closeDatepicker()">
        </mat-calendar>
        <div class="calendar-actions">
          <button mat-button class="btn btn-default btn-group style-button" (click)="closeDatepicker()" i18n="@@commonFeedbackCancelButton">Cancel</button>
          <button mat-button [disabled]="!endDate" class="btn apply-button" (click)="onDateRangeChange()" i18n="@@SimpleApplyButton">Apply</button>
        </div>
      </div>
      <button *ngIf="textStartDate" class="link-button clear-datepicker-button" i18n="Clear@@DatepickerClear" (click)="onClearDateRange()">Clear</button>
    </div>

    <div class="margin-clear" *ngIf="['accounts', 'refs'].includes(eventAction)">
      <button class="dropdown-item clear-all-label" tabindex="0" (click)="clearAllFilters()" *ngIf="filtersChanged()" i18n="@@UsersFilterClearAll">
        Clear all
      </button>
    </div>

    <button *ngIf="!showDownloadDropdown()" class="btn btn-default download margin-button style-button" (click)="downloadReport()">
      <i class="glyphicon glyphicon-download-alt"></i>
      <span i18n="@@analyticsChartDownload" class="ng-scope"> Download</span>
    </button>
    <div *ngIf="showDownloadDropdown()" class="dropdown margin-button">
      <button id="downloadDropdown" class="btn btn-default dropdown-toggle style-button" type="button" data-toggle="dropdown" aria-haspopup="true" aria-expanded="true">
        <i class="glyphicon glyphicon-download-alt"></i>
        <span class="ng-scope download-dropdown-button" i18n="@@analyticsChartDownload"> Download</span>
        <span class="caret"></span>
      </button>
      <ul class="dropdown-menu thick-tooltip dropdown-menu-right">
        <li class="dropdown-menu-item text-left">
          <a class="download-dropdown-item" href="javascript:void(0);" (click)="downloadReport()">
            <span class="dropdown-item-title" i18n="@@selectedGATitle">Selected data</span>
            <div>
              <span class="dropdown-item-subtitle" i18n="@@selectedGASubtitle">Available starting April 2023</span>
            </div>
          </a>
        </li>
        <li class="dropdown-menu-item text-left">
          <a class="download-dropdown-item" href="javascript:void(0);" (click)="downloadHistoricalReport()">
            <span class="dropdown-item-title" i18n="@@historicalGATitle">Historical data</span>
            <div>
              <span class="dropdown-item-subtitle" i18n="@@historicalGASubtitle">Prior to April 2023</span>
            </div>
          </a>
        </li>
      </ul>
    </div>
  </div>

  <div id="filtersSection" class="row filters" *ngIf="showFilters">
    <div class="btn-group dropdown-container" dropdown [outsideClick]="'disabled'">
      <button dropdownToggle id="roleFilter" class="btn btn-default dropdown-toggle style-button" i18n="@@adminUserFilterRole">
        Role {{ selectedRolesSummary() }}
        <span class="caret"></span>
      </button>
      <ul *dropdownMenu class="dropdown-menu dropdown-menu-filters thick" role="menu" (click)="$event.stopPropagation()">
        <li *ngFor="let option of roleOptions" class="row-filters">
          <label class="dropdown-item">
            <input type="checkbox" class="checkboxs-filters" [indeterminate]="option.label === 'All' ? isRoleIndeterminate : false"
                   [ngModel]="option.checked" (ngModelChange)="onRoleOptionChange($event, option)">
            {{ option.label }}
          </label>
        </li>
      </ul>
    </div>
    <span>&nbsp;&nbsp;</span>
    <span>
      <div class="btn-group dropdown-container" dropdown [outsideClick]="'disabled'">
        <button dropdownToggle id="areaFilter" class="btn btn-default dropdown-toggle style-button" i18n="@@adminUserFilterAoF">
          Area of focus {{ selectedAreaSummary() }}
         <span class="caret"></span>
        </button>
        <ul *dropdownMenu class="dropdown-menu dropdown-menu-filters thick" role="menu" (click)="$event.stopPropagation()">
        <li *ngFor="let option of areaOptions" class="row-filters">
            <label class="dropdown-item">
              <input type="checkbox" class="checkboxs-filters" [indeterminate]="option.label === 'All' ? isAreaIndeterminate : false"
                     [(ngModel)]="option.checked" (ngModelChange)="onAreaOptionChange($event, option)">
              {{ option.label }}
            </label>
          </li>
        </ul>
      </div>
    </span>
    <span>&nbsp;&nbsp;</span>
    <span>
      <div class="btn-group dropdown-container" dropdown *ngIf="showAdditionalProfileInformation" [outsideClick]="'disabled'">
        <button dropdownToggle id="additionalFilter" class="btn btn-default dropdown-toggle style-button">
          {{ additionalProfileInformationLabel + selectedAdditionalSummary()}}
          <span class="caret"></span>
        </button>
        <ul *dropdownMenu class="dropdown-menu dropdown-menu-filters thick" role="menu" (click)="$event.stopPropagation()">
          <li *ngFor="let option of additionalOptions" class="row-filters">
            <label class="dropdown-item">
              <input type="checkbox" class="checkboxs-filters" [indeterminate]="option.label === 'All' ? isAdditionalIndeterminate : false"
                     [(ngModel)]="option.checked" (ngModelChange)="onAdditionalOptionChange($event, option)">
              {{ option.label }}
            </label>
          </li>
        </ul>
      </div>
    </span>
    <span>&nbsp;&nbsp;</span>
    <button class="btn btn-primary apply-button" (click)="applyFilters()" [disabled]="!filtersChanged()" i18n="@@UsersAnalyticsApplyButton">
      <span aria-hidden="true"></span> Apply filters
    </button>
  </div>

  <div #googleChartContainer class="row" [ngClass]="{'margin-chart': showFilters}" *ngIf="(!eventAction || ['accounts', 'refs'].includes(eventAction)) && !isEmptyData">
    <div *ngIf="showSpinner">
      <div class="spinner-background"></div>
      <div class="spinner"></div>
    </div>
     <google-chart
      *ngIf="googleChartData" tabindex="0"
      [type]="googleChartData.chartType"
      [data]="googleChartData.dataTable"
      [options]="googleChartData.options"
      [formatters]="googleChartData.formatters"
      [columns]="googleChartData.columns"
      (window:resize)="onResize($event)"
    >
    </google-chart>
  </div>

  <div class="row" *ngIf="isEmptyData">
    <div class="not-found">
      <p i18n="@@analyticsNoData">No data found.</p>
    </div>
  </div>
</div>

<span class="hidden" #toasterGAInvalidDateRange i18n="@@analyticsGAInvalidDateRange">Invalid Date Range: End-date Cannot Precede Start-date.</span>
<div class="calendar-backdrop" (click)="calendarOpen = false" *ngIf="calendarOpen"></div>
